<template>
  <div class="enterprisesSetBox">
    <el-form
      v-if="!isShowEditor"
      ref="form"
      v-loading="enterpriseLoading"
      :model="result"
      label-width="140px"
      label-position="left"
    >
      <el-form-item label="企业名称:">
        <div v-if="result.enterprise_name && canEditEnterprise" class="enterprisesBox item">
          <p class="row-name">
            {{ result.enterprise_name }}
          </p>
          <el-button class="edit" type="text" @click="canEditEnterpriseMe">修改</el-button>
        </div>
        <div v-else>
          <el-input
            ref="name-input"
            v-model="result.enterprise_name"
            :maxlength="10"
            :minlength="2"
            placeholder="支持中文、字母、数字的组合，2-10个字符"
            class="enterprise"
            :class="enterpriseError ? 'error' : null"
            @blur="enterpriseNameBlur()"
          />
          <span v-show="enterpriseError" class="errorText">
            <i class="iconfont icon-ai54" />
            支持中文、字母、数字的组合，2-10个字符
          </span>
          <i v-show="result.enterprise_name" class="propmptText">
            支持中文、字母、数字的组合，2-10个字符
          </i>
        </div>
      </el-form-item>
      <el-form-item label="小程序名称:">
        <!-- <el-input v-model="result.app_name" placeholder="请输入小程序名称" clearable></el-input> -->
        <div v-if="result.app_name && canEditWxmini" class="enterprisesBox item">
          <p class="row-name">
            {{ result.app_name }}
          </p>
          <el-button class="edit" type="text" @click="canEditWxminiMe">修改</el-button>
        </div>
        <div v-else>
          <el-input
            ref="wxmini-input"
            v-model="result.app_name"
            placeholder="支持中文、字母、数字的组合，2-10个字符"
            class="wxmini"
            :maxlength="10"
            :minlength="2"
            :class="miniNameError ? 'error' : null"
            @blur="wxminiNameBlur()"
          />
          <span v-show="miniNameError" class="errorText">
            <i class="iconfont icon-ai54" />
            支持中文、字母、数字的组合，2-10个字符
          </span>
          <i v-show="result.app_name" class="propmptText">支持中文、字母、数字的组合，2-10个字符</i>
        </div>
      </el-form-item>
      <el-form-item class="wxmini-name-lable" label="小程序检视账号:">
        <div class="app_name item item2">
          <div class="leftContent row-name">
            <div class="uesr-info-wrap">
              <p class="name">
                用户名 |
                <i class="name-password name-words">
                  {{ result.app_user ? result.app_user : '-' }}
                </i>
              </p>
              <p class="password">
                密码 |
                <i class="password-words name-password">
                  {{ result.app_pwd ? result.app_pwd : '-' }}
                </i>
              </p>
            </div>

            <el-button class="edit" type="text" @click="dialogAddExaminAccount = true">
              编辑
            </el-button>
          </div>
          <div>
            <AddExaminAccount
              v-if="dialogAddExaminAccount"
              :account-name="result.app_user"
              :account-pass-word="result.app_pwd"
              @hideDialog="hideAddExaminAccountDialog"
              @saveNamePassword="saveExamin"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="select-warp" label="小程序检视领域:">
        <div class="select item item2">
          <!-- 检视账号多选 -->
          <el-select
            v-model="accounts"
            class="accountsSelects"
            multiple
            :multiple-limit="2"
            placeholder="请选择"
          >
            <el-option
              v-for="item in accountsFields"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="法律&隐私声明:">
        <div class="lawContent item item2 row-name">
          <div class="upLeftBox">
            <p v-if="!result.legal_statement_time" class="none">-</p>
            <p v-else class="uped">
              已上传
              <i class="time">上传时间:{{ companyConfig.legal_statement_time }}</i>
            </p>
          </div>
          <div class="upRightBox">
            <el-button type="text" class="edit" @click="editDialog('law')">编辑</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="授权书:">
        <div class="authorization item item2 row-name">
          <div class="upLeftBox">
            <p v-if="!result.authorization_time" class="none">-</p>
            <p v-else class="uped">
              已上传
              <i class="time">上传时间:{{ companyConfig.authorization_time }}</i>
            </p>
          </div>
          <div class="upRightBox">
            <el-button type="text" class="edit" @click="editDialog('right')">编辑</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="upLoad mini" label="小程序Logo:">
        <FileUpload
          class="app"
          v-model="result.app_logo"
          @onError="FileUploadError"
          @beforeAvatarUpload="beforeAvatarUpload"
        />
        <div v-if="result.app_logo" class="mask-words app" @click="result.app_logo = ''">
          <div class="shadow">删除</div>
        </div>
        <span v-if="upLogoError && !result.app_logo" class="upErrorText">
          <i class="iconfont icon-ai54" />
          请选择高度小于80px,长度小于80px,且格式为png的图片
        </span>
        <p class="promptText">尺寸为80px*80px，格式为png</p>
      </el-form-item>
      <el-form-item class="upLoad enterprise" label="企业Logo:">
        <FileUpload
          class="enterprise"
          v-model="result.enterprise_logo"
          @onError="FileUploadEnterpriseError"
          @beforeAvatarUpload="beforeEnterpriseUpload"
        />
        <div
          v-if="result.enterprise_logo"
          class="mask-words enterprise"
          @click="result.enterprise_logo = ''"
        >
          <div class="shadow">删除</div>
        </div>
        <span v-if="upEnterpriseLogoError && !result.enterprise_logo" class="upErrorText">
          <i class="iconfont icon-ai54" />
          请选择高度50px,长度小于244px,且格式为png的图片
        </span>
        <p class="promptText">尺寸为244px*50px，格式为png</p>
      </el-form-item>
      <el-form-item class="upLoad loading" label="开屏页图片:">
        <FileUpload
          class="loading"
          v-model="result.loading_img"
          :file-type-be-jpg="true"
          :file-size="0.2"
          @onError="FileUploadEnterpriseError"
          @beforeAvatarUpload="beforeupLoadingImgUpload"
        />
        <div v-if="result.loading_img" class="mask-words" @click="result.loading_img = ''">
          <div class="shadow">删除</div>
        </div>
        <span v-if="upLoadingImgError && !result.loading_img" class="upErrorText">
          <i class="iconfont icon-ai54" />
          请选择750px*1624px，格式为png、jpg，不超过200k的图片
        </span>
        <p class="promptText" @click="result.loading_img = ''">
          建议比例750px*1624px，格式为png、jpg，不超过200k
        </p>
      </el-form-item>
      <el-form-item class="doctor-display-label" label="代表端医生库展现方式:">
        <div class="row-name">
          <el-radio-group v-model="result.order_by">
            <el-radio label="1">按医生排列</el-radio>
            <el-radio label="2">按医院排列</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item class="doctor-display-label" label="匿名评论:">
        <div class="row-name">
          <el-radio-group v-model="result.is_anonymous">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item class="submit" label-width="0">
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
    <DialogQuillEdit
      v-if="privacyLawDialog"
      :dialog-title="dialogTitle"
      :dialog-visible="privacyLawDialog"
      :content="editContent"
      @closeDialog="closePrivacyLawDialog"
      @upData="upDataPrivacyLaw"
      @getContent="getContent"
    />
  </div>
</template>
<script>
import AddExaminAccount from '@/components/addExaminAccount';
// import api from './api';
import FileUpload from '@/components/fileUpload/index';
import DialogQuillEdit from '@/components/dialog-quill-edit/index';
import { dateFormat } from '@/utils/time.js';
import {
  getDomainInfoListApi, // 获取领域列表
  GetCompanyInfo,
  SaveCompanyInfo,
} from '@/api/setUser';

export default {
  name: 'EnterprisesSet',
  components: {
    AddExaminAccount,
    FileUpload,
    DialogQuillEdit,
    // quillEditor,
  },
  data() {
    return {
      enterpriseLoading: false,
      dialogTitle: '',
      currentDialog: '', // 当前弹窗   'right' 授权   law 法律
      privacyLawDialog: false, // 法律弹窗
      authorizationLawDialog: false, // 授权弹窗
      enterpriseNameRegE: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,10}$/ /* 企业名称正则表达式 */,
      miniProgramNameRegE: /^[\u4e00-\u9fa5a-zA-Z0-9]{2,10}$/ /* 小程序名称正则表达式 */,
      form: {
        enterprise_name: '',
        app_name: '',
      },
      editContent: '',
      result: {
        enterprise_name: '' /* 企业名称 */,
        app_name: '' /* 微信小程序名称 */,
        app_user: '' /* 检视账号用户名 */,
        app_pwd: '' /* 检视账号密码 */,
        authorization: '' /* 授权书*/,
        legal_statement: '' /* 隐私和法律 */,
        app_logo: '' /* 小程序logo */,
        enterprise_logo: '' /* 企业logo */,
        loading_img: '' /* 小程序开屏图片 */,
        legal_statement_time: '' /* 法律&隐私声明更新时间 */,
        authorization_time: '' /* 授权书更新时间 */,
        app_domain: '',
        order_by: '' /* 代表端医生库展现方式 */,
        is_anonymous: 1, // 是否匿名, 默认匿名 0不开启 1开启
      },
      accounts: [] /* 检视账号选中领域 */,
      accountsFields: [
        {
          value: 0,
          label: '内科',
        },
        {
          value: 1,
          label: '外科',
        },
        {
          value: 3,
          label: '耳鼻喉科',
        },
        {
          value: 4,
          label: '皮肤科',
        },
        {
          value: 5,
          label: '呼吸科',
        },
      ] /* 检视账号选择领域项 */,
      canEditEnterprise: true /* 能否编辑企业名称 */,
      enterpriseError: false /* 企业名称输入错误 */,
      canEditWxmini: true /* 能否编辑小程序名称 */,
      miniNameError: false /* 小程序输入错误 */,
      dialogAddExaminAccount: false /* 检视账号弹窗显示隐藏 */,
      upLogoError: false /* 上传小程序logo出错 */,
      upEnterpriseLogoError: false /* 上传企业logo出错 */,
      upLoadingImgError: false /* 上传开屏页出错 */,
      isShowEditor: false /* 是否显示编辑 */,
      htmlText: '' /* 编辑内容 */,
      companyConfig: {
        authorization_time: '',
        legal_statement_time: '',
        name: {} /* 企业名称 */,
        app_name: {} /* 微信小程序名称 */,
        userInfo: {},
        authorization: {} /* 授权书*/,
        legal_statement: {} /* 隐私和法律 */,
        app_logo: {} /* 小程序logo */,
        enterprise_logo: {} /* 小程序logo */,
      } /* 后台返回的配置信息 */,
    };
  },
  mounted() {},
  created() {
    this.getQueryTag();
    this.getQueryCompanyConfig();
  },
  methods: {
    beforeAvatarUpload() {
      this.upLogoError = true;
    },
    beforeEnterpriseUpload() {
      this.upEnterpriseLogoError = true;
    },
    beforeupLoadingImgUpload() {
      this.upLoadingImgError = true;
    },
    /**
     * 小程序文件上传失败
     */
    FileUploadError() {
      this.upLogoError = true;
    },
    /**
     * 企业文件上传失败
     */
    FileUploadEnterpriseError() {
      this.upEnterpriseLogoError = true;
    },
    /**
     * 打开法律弹窗
     */
    editDialog(type) {
      this.privacyLawDialog = true;
      this.currentDialog = type;
      const isLaw = type === 'law';
      this.$nextTick(() => {
        isLaw ? (this.dialogTitle = '编辑法律&隐私声明') : (this.dialogTitle = '授权书');

        this.editContent = this.result[isLaw ? 'legal_statement' : 'authorization'];
      });
    },
    /**
     *更新富文本数据
     */
    upDataPrivacyLaw() {
      this.privacyLawDialog = false;
      if (this.currentDialog === 'law') {
        this.result.legal_statement_time = new Date().getTime() / 1000;
        this.companyConfig.legal_statement_time = dateFormat(new Date(), 'YYYY/MM/dd');
      } else {
        this.result.authorization_time = new Date().getTime() / 1000;
        this.companyConfig.authorization_time = dateFormat(new Date(), 'YYYY/MM/dd');
      }
    },

    /**
     * 关闭弹窗
     */
    closePrivacyLawDialog() {
      this.privacyLawDialog = false;
    },
    /**
     * 获取法律富文本的值
     */
    getContent(e) {
      this.currentDialog === 'law'
        ? (this.result.legal_statement = e)
        : (this.result.authorization = e);
    },
    /**
     * 查询标签
     */
    async getQueryTag() {
      // const params = {
      //   page_size: 20,
      //   page_index: 1,
      // };
      getDomainInfoListApi().then((res) => {
        if (res) {
          this.accountsFields = res.list?.map((item) => ({
            value: item.id,
            label: item.domain_name,
          }));
        }
      });

      // const res = await this.$requestData(api.queryTag, params);
    },
    /**
     *更改企业配置
     */
    saveCompanyConfig() {
      this.enterpriseLoading = true;
      this.result.app_domain = this.accounts.join('|');

      SaveCompanyInfo(this.result)
        .then(() => {
          this.$message.success('保存成功');
          this.getQueryCompanyConfig();
        })
        .catch((err) => {
          this.$message(err.message);
        });
      this.enterpriseLoading = false;
    },
    /**
     *查询企业配置
     */
    async getQueryCompanyConfig() {
      const params = {};
      this.enterpriseLoading = true;

      // const res = await this.$requestData(api.queryCompanyConfig, params);
      try {
        const res = await GetCompanyInfo(params);
        this.result = Object.assign({}, res);
        this.companyConfig.authorization_time = dateFormat(
          new Date(this.result.authorization_time * 1000),
          'YYYY/MM/dd',
        );
        this.companyConfig.legal_statement_time = dateFormat(
          new Date(this.result.legal_statement_time * 1000),
          'YYYY/MM/dd',
        );
        res.app_domain && (this.accounts = res.app_domain.split('|').map(Number));
      } catch {}
      this.enterpriseLoading = false;
    },

    /**
     *提交验证·
     */

    verifyParams() {
      const { authorization /* 授权书*/ } = this.result;
      const appUser = this.result.app_user; // 检视账号用户名
      const appPwd = this.result.app_pwd; // 检视账号密码
      const legalStatement = this.result.legal_statement; // 隐私和法律
      const appLogo = this.result.app_logo; // 小程序logo
      const enterpriseLogo = this.result.enterprise_logo; // 企业logo
      if (!this.enterpriseNameBlur()) {
        this.$message.error('请输入正确的企业名称');
        return false;
      }
      if (!this.wxminiNameBlur()) {
        this.$message.error('请输入正确的小程序名称');
        return false;
      }
      if (!appUser && appPwd) {
        this.$message.error('请输入账户名或密码');
        return false;
      }
      if (!authorization.replace(/<.*?>/gi, '').trim()) {
        this.$message.error('请上传授权书');
        return false;
      }
      if (!legalStatement.replace(/<.*?>/gi, '').trim()) {
        this.$message.error('请上传法律和隐私和声明');
        return false;
      }
      if (!appLogo) {
        this.$message.error('请上传小程序logo');
        return false;
      }
      if (!enterpriseLogo) {
        this.$message.error('请上传企业logo');
        return false;
      }

      return true;
    },
    /**
     *点击提交按钮
     */
    async onSubmit() {
      if (this.verifyParams()) {
        this.saveCompanyConfig();
      }
    },
    /* 企业名称改变触发 */
    enterpriseNameChange(value) {
      const type = this.enterpriseNameRegE.test(value.trim());
      if (type) {
        this.result.name = value;
        this.canEditEnterprise = true;
        this.enterpriseError = false;
        return true;
      }
      this.enterpriseError = true;
      return false;
    },
    /* 企业名称失去焦点触发 */
    enterpriseNameBlur() {
      const type = this.enterpriseNameRegE.test(this.result.enterprise_name.trim());
      if (type) {
        // this.result["name"] = this.form.name;
        this.canEditEnterprise = true;
        this.enterpriseError = false;
        return true;
      }
      this.enterpriseError = true;
      this.canEditEnterprise = false;
      return false;
    },
    /* 企业名称点击修改触发 */
    canEditEnterpriseMe() {
      this.canEditEnterprise = false;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs['name-input'].$refs.input.focus();
      });
    },
    /* 小程序名称改变触发 */
    wxminiNameChange(value) {
      const type = this.miniProgramNameRegE.test(value.trim());
      if (type) {
        this.result.app_name = value;
        this.canEditWxmini = true;
        this.miniNameError = false;
        return true;
      }
      this.miniNameError = true;
      return false;
    },
    /* 小程序名称失去焦点触发 */
    wxminiNameBlur() {
      const type = this.miniProgramNameRegE.test(this.result.app_name.trim());

      if (type) {
        // this.result["app_name"] = this.form.app_name;
        this.canEditWxmini = true;
        this.miniNameError = false;
        return true;
      }
      this.canEditWxmini = false;
      this.miniNameError = true;
      return false;
    },
    /* 企业名称点击修改触发 */
    canEditWxminiMe() {
      this.canEditWxmini = false;
      this.$nextTick(() => {
        // 自动获取焦点 element组件autofocus失效
        this.$refs['wxmini-input'].$refs.input.focus();
      });
    },
    /* 关闭检视账号弹窗 */
    hideAddExaminAccountDialog() {
      this.dialogAddExaminAccount = false;
    },
    /* 获取检视账号 */
    saveExamin(obj) {
      this.result.app_user = obj.name;
      this.result.app_pwd = obj.password;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
